import React, { memo } from 'react';
import { Preset } from '@lux/text';
import { NavigationWrapper, NavigationIcon, NavigationLabel, Notification, NavigationItemAriaLabel, IconWrapper, } from './styles';
export const _NavigationItem = (props) => {
    const { href, icon, label, notificationCounter = null, onClick, forceLabelVisibility = false, id, ariaLabel, ariaExpanded, children, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(NavigationWrapper, { onClick: onClick, id: id, "aria-labelledby": `${id}-label`, "aria-haspopup": ariaExpanded !== undefined, "aria-expanded": ariaExpanded, ...(href ? { as: 'a', href } : {}) },
            React.createElement(NavigationIcon, { role: "none" },
                React.createElement(IconWrapper, null, icon),
                notificationCounter > 0 && (React.createElement(Notification, { preset: Preset.XS }, notificationCounter))),
            React.createElement(NavigationLabel, { forceLabelVisibility: forceLabelVisibility }, label),
            React.createElement(NavigationItemAriaLabel, { id: `${id}-label` }, ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label)),
        children));
};
export const NavigationItem = memo(_NavigationItem);
//# sourceMappingURL=index.js.map